
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Scapholunate_instability',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Scapholunate_instability.vue